import { useState } from 'react';
import { GalleryLayout, GalleryPhoto, mediaUrl, normalizeLayout } from '../../../lib/gallery/api';

const PAGE_SIZE = 60;

export interface IPhotoGridProps {
    photos: GalleryPhoto[];
    onOpen: (photo: GalleryPhoto) => void;
    layout?: GalleryLayout | string;
}

const PhotoThumb = ({
    photo,
    onOpen,
    className,
}: {
    photo: GalleryPhoto;
    onOpen: (photo: GalleryPhoto) => void;
    className?: string;
}) => {
    const [failed, setFailed] = useState(false);

    return (
        <button
            type="button"
            className={`galeria__photo${className ? ` ${className}` : ''}`}
            onClick={() => onOpen(photo)}
            aria-label={`Otwórz zdjęcie ${photo.name}`}
        >
            {failed
                ? <span className="galeria__photo-fallback">brak podglądu</span>
                : <img src={mediaUrl(photo.path, 'thumb', photo.m)} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} />}
        </button>
    );
};

// Duże foldery renderujemy partiami — przeglądarka nie musi tworzyć setek elementów naraz.
export const PhotoGrid = ({ photos, onOpen, layout: layoutProp }: IPhotoGridProps) => {
    const layout = normalizeLayout(layoutProp);
    const [visible, setVisible] = useState(PAGE_SIZE);
    const slice = photos.slice(0, visible);

    return (
        <>
            <div className={`galeria__photos galeria__photos--${layout}`}>
                {slice.map((photo, i) => (
                    <PhotoThumb
                        key={photo.path}
                        photo={photo}
                        onOpen={onOpen}
                        className={layout === 'hero' && i === 0 ? 'galeria__photo--hero' : undefined}
                    />
                ))}
            </div>
            {visible < photos.length && (
                <div className="custom-button__link-wrapper galeria__more">
                    <button type="button" className="custom-button" onClick={() => setVisible((v) => v + PAGE_SIZE)}>
                        Pokaż więcej ({photos.length - visible})
                    </button>
                </div>
            )}
        </>
    );
};
